import { lazy } from "react";
import { MAIN_ROUTES, ROUTES } from "../constants";

// Planning
const PlanningMain = lazy(() => import("../view/pages/Planning/Planning"));
const BookManagement = lazy(() => import("../view/pages/Planning/resources"));
const AddResources = lazy(() =>
  import("../view/pages/Planning/resources/addResources"),
);
const Microscopic = lazy(() => import("../view/pages/Planning/microscopic"));
const Telescopic = lazy(() => import("../view/pages/Planning/telescopic"));
const Consultant = lazy(() => import("../view/pages/Consultancy"));
const WeeklyRoutine = lazy(() =>
  import("../view/pages/Planning/weeklyRoutine"),
);
// Profile
const Profile = lazy(() => import("../view/pages/Profile/profile"));
const Account = lazy(() => import("../view/pages/Profile/account"));
const Invoices = lazy(() => import("../view/pages/Profile/invoices"));
const Wallet = lazy(() => import("../view/pages/Profile/wallet"));
const Setting = lazy(() => import("../view/pages/Profile/setting"));
// Pay
const Packages = lazy(() => import("../view/pages/Pay/packages"));
const PackagesOld = lazy(() => import("../view/pages/Pay/packages_old"));
const PlanCustomizing = lazy(() => import("../view/pages/Pay/planCustomizing"));
const Invoice = lazy(() => import("../view/pages/Pay/invoice"));
const Package = lazy(() => import("../view/pages/Pay/package"));
const RefundedInvoice = lazy(() => import("../view/pages/Pay/refundedInvoice"));
const TeacherSelection = lazy(() =>
  import("../view/pages/Pay/teacherSelection"),
);
// Reserve Appointment
const ReserveAppointment = lazy(() =>
  import("../view/pages/reserveAppointment/reserveAppointment"),
);
// Tests
const Quizzes = lazy(() => import("../view/pages/Tests/quizzes"));
const ExamLanding = lazy(() => import("../view/pages/Tests/examLanding"));
// Support
const Messages = lazy(() => import("../view/pages/Support/messages"));
const Chat = lazy(() => import("../view/pages/chat"));

// Dashboard
const Dashboard = lazy(() => import("../view/pages/dashboard/dashboard"));
// Others
const NotFound = lazy(() => import("../view/pages/404"));
const DeleteAccount = lazy(() => import("../view/pages/deleteAccount"));

// Session
const Session = lazy(() => import("../view/pages/Session"));
const SessionLanding = lazy(() => import("../view/pages/Session/landing"));
const SessionForm = lazy(() => import("../view/pages/Session/sessionForm"));
const SessionRequest = lazy(() =>
  import("../view/pages/Session/sessionRequest"),
);

// Hall
const Hall = lazy(() => import("../view/pages/hall"));
const HallLanding = lazy(() => import("../view/pages/hall/landing"));
const CustomHallLanding = lazy(() =>
  import("../view/pages/hall/customLanding"),
);
const HallSearch = lazy(() => import("../view/pages/hall/search"));
const Counselor = lazy(() => import("../view/pages/hall/counselor"));
const HallPackage = lazy(() => import("../view/pages/hall/package"));
const HallField = lazy(() => import("../view/pages/hall/field"));

const consultancyHistory = lazy(() =>
  import("../view/pages/consultancyHistory"),
);
const myCounselor = lazy(() => import("../view/pages/myCounselor"));

// settings
const SettingsMenu = lazy(() => import("../view/pages/settings"));
const Settings = lazy(() => import("../view/pages/settings/settings"));
const ExamSettings = lazy(() => import("../view/pages/settings/examSettings"));

//initila from
const initialFrom = lazy(() => import("../view/pages/initial"));

const MainLayout = lazy(() => import("../view/layout/main"));
const PlanningLayout = lazy(() => import("../view/layout/planningLayout"));

const mainRoutes = [
  // Planning routes
  {
    title: ROUTES.MAIN_PLANNING.TITLE,
    path: ROUTES.MAIN_PLANNING.PATH,
    component: PlanningMain,
    exact: true,
    icon: ROUTES.MICROSCOPIC_PLAN.ICON,
    layout: PlanningLayout,
    loginRequired: true,
  },
  {
    title: ROUTES.MICROSCOPIC_PLAN.TITLE,
    path: ROUTES.MICROSCOPIC_PLAN.PATH,
    component: Microscopic,
    exact: true,
    subRoute: MAIN_ROUTES.PLANNING.PATH,
    icon: ROUTES.MICROSCOPIC_PLAN.ICON,
    layout: PlanningLayout,
    loginRequired: true,
  },
  {
    title: ROUTES.TIMING_PLAN.TITLE,
    path: ROUTES.TIMING_PLAN.PATH,
    component: WeeklyRoutine,
    exact: true,
    subRoute: MAIN_ROUTES.PLANNING.PATH,
    layout: PlanningLayout,
    loginRequired: true,
  },
  {
    title: ROUTES.BOOK_MANAGEMENT.TITLE,
    path: ROUTES.BOOK_MANAGEMENT.PATH,
    component: BookManagement,
    exact: true,
    subRoute: MAIN_ROUTES.PLANNING.PATH,
    layout: PlanningLayout,
    loginRequired: true,
  },
  {
    title: ROUTES.ADD_RESOURCES.TITLE,
    path: ROUTES.ADD_RESOURCES.PATH,
    component: AddResources,
    exact: true,
    subRoute: MAIN_ROUTES.PLANNING.PATH,
    layout: PlanningLayout,
    loginRequired: true,
  },
  {
    title: ROUTES.TELESCOPIC_PLAN.TITLE,
    path: ROUTES.TELESCOPIC_PLAN.PATH,
    component: Telescopic,
    exact: true,
    subRoute: MAIN_ROUTES.PLANNING.PATH,
    layout: PlanningLayout,
    loginRequired: true,
  },
  {
    title: ROUTES.CONSULTANT.TITLE,
    path: ROUTES.CONSULTANT.PATH,
    component: Consultant,
    exact: true,
    layout: MainLayout,
    loginRequired: true,
  },
  {
    title: ROUTES.PACKAGES.TITLE,
    path: ROUTES.PACKAGES.PATH,
    exact: true,
    component: Packages,
    layout: MainLayout,
    loginRequired: true,
  },
  {
    title: ROUTES.PLAN_CUSTOMIZING.TITLE,
    path: ROUTES.PLAN_CUSTOMIZING.PATH,
    component: PlanCustomizing,
    layout: MainLayout,
    loginRequired: true,
  },
  {
    title: ROUTES.INVOICE.TITLE,
    path: ROUTES.INVOICE.PATH,
    component: Invoice,
    layout: MainLayout,
    loginRequired: true,
  },
  {
    title: ROUTES.PACKAGE.TITLE,
    path: ROUTES.PACKAGE.PATH,
    component: Package,
    layout: MainLayout,
    loginRequired: true,
  },
  {
    title: ROUTES.REFUNDED_INVOICE.TITLE,
    path: ROUTES.REFUNDED_INVOICE.PATH,
    component: RefundedInvoice,
    layout: MainLayout,
    loginRequired: true,
  },
  {
    title: ROUTES.TEACHER_SELECTION.TITLE,
    path: ROUTES.TEACHER_SELECTION.PATH,
    component: TeacherSelection,
    layout: MainLayout,
    loginRequired: false,
  },
  // // Reserve Appointment
  {
    title: ROUTES.RESERVE_APPOINTMENT.TITLE,
    path: ROUTES.RESERVE_APPOINTMENT.PATH,
    component: ReserveAppointment,
    layout: MainLayout,
    loginRequired: true,
  },
  // Profile routes
  {
    title: ROUTES.PROFILE.TITLE,
    path: ROUTES.PROFILE.PATH,
    component: Profile,
    subRoutes: [
      {
        title: ROUTES.PROFILE_ACCOUNT.TITLE,
        path: ROUTES.PROFILE_ACCOUNT.PATH,
        component: Account,
        exact: true,
        icon: ROUTES.PROFILE_ACCOUNT.ICON,
        consultantPermissionDenied: true,
      },
      {
        title: ROUTES.PROFILE_INVOICES.TITLE,
        path: ROUTES.PROFILE_INVOICES.PATH,
        component: Invoices,
        exact: true,
        icon: ROUTES.PROFILE_INVOICES.ICON,
      },
      {
        title: ROUTES.PROFILE_WALLET.TITLE,
        path: ROUTES.PROFILE_WALLET.PATH,
        component: Wallet,
        exact: true,
        icon: ROUTES.PROFILE_WALLET.ICON,
      },
      {
        title: ROUTES.PROFILE_SETTING.TITLE,
        path: ROUTES.PROFILE_SETTING.PATH,
        component: Setting,
        exact: true,
        icon: ROUTES.PROFILE_SETTING.ICON,
      },
    ],
    layout: MainLayout,
    loginRequired: true,
  },
  {
    title: ROUTES.CONSULTANCY_HISTORY.TITLE,
    path: ROUTES.CONSULTANCY_HISTORY.PATH,
    component: consultancyHistory,
    layout: MainLayout,
    loginRequired: true,
  },
  {
    title: ROUTES.COUNSELOR_PROFILE.TITLE,
    path: ROUTES.COUNSELOR_PROFILE.PATH,
    component: myCounselor,
    layout: MainLayout,
    loginRequired: true,
    subRoutes: [
      {
        title: ROUTES.COUNSELOR_PROFILE.TITLE,
        path: ":counselorId",
        component: myCounselor,
        loginRequired: true,
      },
    ],
  },
  // Pay routes
  {
    title: ROUTES.PACKAGES_OLD.TITLE,
    path: ROUTES.PACKAGES_OLD.PATH,
    component: PackagesOld,
    exact: true,
    subRoute: MAIN_ROUTES.PAY.PATH,
    layout: MainLayout,
    loginRequired: true,
  },
  // // Tests routes
  {
    // FIXME: fix the route
    title: ROUTES.QUIZZES.TITLE,
    path: ROUTES.QUIZZES.PATH,
    component: Quizzes,
    exact: true,
    subRoute: MAIN_ROUTES.TESTS.PATH,
    layout: MainLayout,
    loginRequired: true,
  },
  {
    // FIXME: legacy pages
    title: ROUTES.EXAM_LANDING.TITLE,
    path: ROUTES.EXAM_LANDING.PATH,
    component: ExamLanding,
    exact: true,
    subRoute: MAIN_ROUTES.TESTS.PATH,
    layout: MainLayout,
    loginRequired: true,
  },
  // Support routes
  {
    // FIXME: legacy route
    title: ROUTES.MESSAGES.TITLE,
    path: ROUTES.MESSAGES.PATH,
    component: Messages,
    layout: MainLayout,
    loginRequired: true,
  },
  {
    title: ROUTES.CHAT.TITLE,
    path: ROUTES.CHAT.PATH,
    component: Chat,
    layout: MainLayout,
    loginRequired: true,
    subRoutes: [
      {
        title: ROUTES.CHAT.TITLE,
        path: ":chatId",
        component: Chat,
        loginRequired: true,
      },
    ],
  },
  {
    title: ROUTES.SESSION.TITLE,
    path: ROUTES.SESSION.PATH,
    component: Session,
    subRoutes: [
      {
        title: ROUTES.SESSION_LANDING.TITLE,
        path: ROUTES.SESSION_LANDING.PATH,
        component: SessionLanding,
        exact: true,
        subRoute: MAIN_ROUTES.SESSION.PATH,
      },
      {
        title: ROUTES.SESSION_FORM.TITLE,
        path: ROUTES.SESSION_FORM.PATH,
        component: SessionForm,
        exact: true,
        subRoute: MAIN_ROUTES.SESSION.PATH,
      },
      {
        title: ROUTES.SESSION_REQUEST.TITLE,
        path: ROUTES.SESSION_REQUEST.PATH,
        component: SessionRequest,
        exact: true,
        subRoute: MAIN_ROUTES.SESSION.PATH,
      },
    ],
    layout: MainLayout,
    loginRequired: false,
  },
  // Hall
  {
    title: ROUTES.HALL.TITLE,
    path: ROUTES.HALL.PATH,
    component: Hall,
    loginRequired: true,
    subRoutes: [
      {
        title: ROUTES.HALL_LANDING.TITLE,
        path: ROUTES.HALL_LANDING.PATH,
        component: HallLanding,
        exact: true,
        subRoute: MAIN_ROUTES.HALL.PATH,
      },
      {
        title: ROUTES.HALL_CUSTOM_LANDING.TITLE,
        path: `${ROUTES.HALL_CUSTOM_LANDING.PATH}/:slug`,
        component: CustomHallLanding,
        loginRequired: true,
      },
      {
        title: ROUTES.HALL_LANDING.TITLE,
        path: ":counselorId",
        component: Counselor,
        loginRequired: true,
      },
      {
        title: ROUTES.HALL_LANDING.TITLE,
        path: ":counselorId/:packageId",
        component: HallPackage,
        loginRequired: true,
      },
      {
        title: ROUTES.HALL_FIELD.TITLE,
        path: `${ROUTES.HALL_FIELD.PATH}/:fieldId`,
        component: HallField,
        exact: true,
        subRoute: MAIN_ROUTES.HALL.PATH,
      },
      {
        title: ROUTES.HALL_SEARCH.TITLE,
        path: ROUTES.HALL_SEARCH.PATH,
        component: HallSearch,
        exact: true,
        subRoute: MAIN_ROUTES.HALL.PATH,
      },
    ],
  },
  // Dashboard
  {
    title: ROUTES.DASHBOARD.TITLE,
    path: ROUTES.DASHBOARD.PATH,
    component: Dashboard,
    subRoute: MAIN_ROUTES.DASHBOARD.PATH,
    layout: MainLayout,
    loginRequired: true,
  },
  //inital form
  {
    title: ROUTES.INITIAL.TITLE,
    path: ROUTES.INITIAL.PATH,
    component: initialFrom,
    layout: MainLayout,
    loginRequired: true,
  },
  {
    title: "تنظیمات",
    path: ROUTES.SETTINGS.PATH,
    layout: MainLayout,
    loginRequired: true,
    component: SettingsMenu,
    subRoutes: [
      {
        title: ROUTES.SETTINGS_MAIN.TITLE,
        path: ROUTES.SETTINGS_MAIN.PATH,
        component: Settings,
        exact: true,
        subRoute: ROUTES.SETTINGS.PATH,
        icon: ROUTES.SETTINGS.ICON,
      },
      {
        title: ROUTES.SETTINGS_EXAM.TITLE,
        path: ROUTES.SETTINGS_EXAM.PATH,
        component: ExamSettings,
        exact: true,
        subRoute: ROUTES.SETTINGS.PATH,
        icon: ROUTES.SETTINGS_EXAM.ICON,
      },
    ],
  },
  // // Others
  {
    redirect: true,
    path: "/",
    exact: true,
    to: ROUTES.DASHBOARD.PATH,
    navbarName: "Redirect",
  },
  {
    title: ROUTES.NOT_FOUND.TITLE,
    path: ROUTES.NOT_FOUND.PATH,
    component: NotFound,
    layout: MainLayout,
  },
  {
    title: ROUTES.DELETE_ACCOUNT.TITLE,
    path: ROUTES.DELETE_ACCOUNT.PATH,
    component: DeleteAccount,
    layout: MainLayout,
    loginRequired: true,
  },
];

export default mainRoutes;
